type LineGradientProps = {
  color?: 'primary' | 'secondary'
  position?: 'start' | 'end'
}

export const LineGradient = ({color = 'primary', position = 'start'}: LineGradientProps) => {
  return <div className={`${position === 'start' ? 'bg-gradient-to-r' : 'bg-gradient-to-l'} ${color === 'primary' ? 'from-primary' : 'from-secondary'} h-[2px] w-full`}></div>
}